const addNotationValues = (data) => {
    return data.map((item) => {
        return [
            item === null || item === undefined ? ' ' : item,
            null,
            null,
        ]
    }).flat()
}

export default addNotationValues
